import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { delay, finalize, take } from 'rxjs/operators';

// @dynamic
@Component({
  selector: 'sc-file-viewer',
  templateUrl: './sc-file-viewer-dialog.component.html',
  styleUrls: ['./sc-file-viewer-dialog.component.scss']
})
export class ScFileViewerDialogComponent implements OnInit {
  public url: string;
  public loading: boolean;

  constructor(
    public dialogRef: MatDialogRef<ScFileViewerDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      src: File | string;
      type: string;
      title: string;
    },
    private _httpClient: HttpClient
  ) {
    if (typeof data.src === 'string') {
      this.loading = true;
      this._httpClient
        .get(data.src, { responseType: 'arraybuffer' })
        .pipe(
          take(1),
          finalize(() => (this.loading = false)),
          delay(10)
        )
        .subscribe((arraybuffer: any) => {
          const blob = new Blob([arraybuffer], { type: data.type });
          this.url = URL.createObjectURL(blob);
        });
    } else {
      this.url = URL.createObjectURL(data.src);
    }
  }

  ngOnInit(): void {}
}
